// extracted by mini-css-extract-plugin
export default {"container":"TextAreaResizable_container__lkvrk","counter":"TextAreaResizable_counter__PtPya"};